import { render, staticRenderFns } from "./NewsfeedEdit.vue?vue&type=template&id=14b49c50&"
import script from "./NewsfeedEdit.vue?vue&type=script&lang=js&"
export * from "./NewsfeedEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports